// extracted by mini-css-extract-plugin
module.exports = {"day":"styles_day__2MEFe","dayText":"styles_dayText__3nYRt"};